import React, { useEffect, useRef, useState, useMemo } from 'react';
import { ReactFlowProvider } from 'react-flow-renderer';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import NavigationBar from './NavigationBar';
import ETLMapping from './Component/Mapping';
import ExitConfirmationModal from './Tabs/ExitConfirmationModal';
import { useDispatch, useSelector } from 'react-redux';
import {
  applySavedMappingIfNeeded,
  fetchResolvedFields,
  getSavedMapping,
  // resetMappingForWorkflow,
  runFieldMappingIfNeeded,
  setConnectionDetailsForWorkflow,
  setFinalConfigPayloadForWorkflow,
  setMappedEntities,
  setUnmappedEntities,
} from '../state/slices/mappingSlice';
import useLogout from '../hooks/useLogout';
import { toast } from 'react-toastify';
import CustomFuzzyToast from './CustomFuzzyToast';

const MappingWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { workflowName: workflowId } = useParams();

  const dispatch = useDispatch();

  const reduxPayload = useSelector(
    (state) => state.mapping.finalConfigPayloadByWorkflow?.[workflowId]
  );

  // const finalConfigPayload = location.state?.finalConfigPayload;
  const finalConfigPayload = location.state?.finalConfigPayload || reduxPayload;
  const finalConfigPayload1 = location.state?.finalConfigPayload;
  const finalConfigPayload2 = reduxPayload;
  const shouldSkipFuzzy = location.state?.shouldSkipFuzzy;
  // const secondaryDestinationId = location.state?.secondaryDestinationId;

  const { secondaryDestinationId, decisionMeta } = location.state || {};
  const isOneToMany = !!(decisionMeta?.destIds?.length > 1 || secondaryDestinationId);


  console.log('shouldSkipFuzzy mapping::', shouldSkipFuzzy);

  console.log('finalConfigPayload:::', finalConfigPayload);

  // updates done by vishal for one to many
  // const isOneToMany = !!secondaryDestinationId;

  // console.log('isOneToMany wrapper::', isOneToMany)
  console.log('finalConfigPayload1:::', finalConfigPayload1);
  console.log('finalConfigPayload2:::', finalConfigPayload2);
  // const canGoNext = location.state?.canGoNext;
  // const mappingLoading = useSelector((state) => state.mapping?.loading);
  // const mappingSaving = useSelector((state) => state.mapping?.saving);

  const { nodes: workflowNodes = [], edges: workflowEdges = [] } = useSelector(
    (state) =>
      state.workflows.nodes ? state.workflows : { nodes: [], edges: [] }
  );

  // const workflowId = useSelector(
  //   (state) =>
  //     state.workflows.list.find((w) => w.workflow_id === workflowName)?.workflow_id
  // );

  const selectedSourceEntities = (finalConfigPayload ?? [])
    .filter((cfg) => cfg.type === 'source')
    .flatMap((cfg) => cfg.selectedEntities.map((ent) => ent.entity_name));

  const selectedDestinationEntities = (finalConfigPayload ?? [])
    .filter((cfg) => cfg.type === 'destination')
    .flatMap((cfg) => cfg.selectedEntities.map((ent) => ent.entity_name));

  const storedAutoFuzzy = useSelector(
    (state) => state.mapping.autoFuzzyEnabledByWorkflow?.[workflowId]
  );
  const autoFuzzyEnabled = storedAutoFuzzy ?? true;

  const mappedEntities = useSelector(
    (state) =>
      state.mapping.mappedEntitiesByWorkflow?.[workflowId] || {
        Source: [],
        Destination: [],
      }
  );
  const unmappedEntities = useSelector(
    (state) =>
      state.mapping.unmappedEntitiesByWorkflow?.[workflowId] || {
        Source: [],
        Destination: [],
      }
  );

  const mappedEdges = useSelector(
    (state) => state.mapping?.mappingsByWorkflow?.[workflowId]?.edges || []
  );

  console.log('mapped Edges:', mappedEdges);

  const manualEdges = mappedEdges.filter((eds) => eds.data?.isManual === true);

  console.log('manual edges:', manualEdges);

  const manualSourceEntities = new Set(
    manualEdges.map((eds) => (eds.sourceHandle || '').split('__')[0])
  );
  const manualDestEntities = new Set(
    manualEdges.map((eds) => (eds.targetHandle || '').split('__')[0])
  );

  console.log('manual Source Entities:', manualSourceEntities);
  console.log('manual Destination Entities:', manualDestEntities);

  const safe = (arr) => (Array.isArray(arr) ? arr : []);

  const newlyAddedEntities = {
    Source: selectedSourceEntities.filter(
      (entity) =>
        !safe(mappedEntities.Source).includes(entity) &&
        !safe(unmappedEntities.Source).includes(entity)
    ),
    Destination: selectedDestinationEntities.filter(
      (entity) =>
        !safe(mappedEntities.Destination).includes(entity) &&
        !safe(unmappedEntities.Destination).includes(entity)
    ),
  };

  // const existingMappingData = useSelector(
  //   (state) => state.mapping?.mappingsByWorkflow?.[workflowName]
  // );

  // const hasSource = workflowNodes.some((node) => node.type === 'sourceNode');
  // const hasDestination = workflowNodes.some(
  //   (node) => node.type === 'destinationNode'
  // );
  // const hasIntegration = workflowNodes.some(
  //   (node) => node.type === 'integrationNode'
  // );

  useEffect(() => {
    if (!finalConfigPayload?.length || !workflowId) return;

    if (finalConfigPayload && workflowId) {
      dispatch(
        setFinalConfigPayloadForWorkflow({ workflowId, finalConfigPayload })
      );
    }
  }, [finalConfigPayload, workflowId, dispatch]);

  const restoredOnceRef = useRef(false);

  useEffect(() => {
    const loadMapping = async () => {
      if (!finalConfigPayload?.length) return;
      // if (!workflowId || !finalConfigPayload?.length) return;

      let resolvedData = null;

      const resolvedRes = await dispatch(
        fetchResolvedFields({
          label: 'FieldResolution',
          workflowId,
          finalConfigPayload,
        })
      );
      resolvedData = resolvedRes?.payload?.result;

      console.log('resolved data:', resolvedData);

      // if(Array.isArray(mappedEntities) && Array.isArray(unmappedEntities)){

      // const entityPayloadForNewMapping = resolvedData.filter(ent => newlyAddedEntities.includes(ent.entity) || unmappedEntities.includes(ent.entity));

      const entityPayloadForNewMapping = resolvedData.filter(
        (ent) =>
          (ent.type === 'source' &&
            (newlyAddedEntities.Source.includes(ent.entity) ||
              unmappedEntities.Source.includes(ent.entity)) &&
            !manualSourceEntities.has(ent.entity)) ||
          (ent.type === 'destination' &&
            (newlyAddedEntities.Destination.includes(ent.entity) ||
              unmappedEntities.Destination.includes(ent.entity)) &&
            !manualDestEntities.has(ent.entity))
      );

      // let saved = null;
      // try {
      //   const result = await dispatch(getSavedMapping(workflowId)).unwrap();
      //   saved = result.data;
      // } catch (err) {
      //   console.error('No saved mapping found:', err);
      // }

      // const hasSaved =
      //   Array.isArray(saved?.mappings) && saved.mappings.length > 0;

      // if (hasSaved && resolvedData) {
      //   dispatch(
      //     applySavedMappingIfNeeded({
      //       workflowName,
      //       mappings: saved.mappings,
      //     })
      //   );
      // } else if (resolvedData) {
      const fieldsForMapping =
        entityPayloadForNewMapping.length > 0
          ? entityPayloadForNewMapping
          : resolvedData || [];

      const hasNewlyAddedEntities =
        newlyAddedEntities.Source.length > 0 ||
        newlyAddedEntities.Destination.length > 0;

      const hasPendingUnmapped =
        fieldsForMapping.some((ent) => {
          if (ent.type === 'source') {
            return safe(unmappedEntities.Source).includes(ent.entity);
          }
          if (ent.type === 'destination') {
            return safe(unmappedEntities.Destination).includes(ent.entity);
          }
          return false;
        });

      const shouldForceAutoMap = hasNewlyAddedEntities || hasPendingUnmapped;

      const shouldAttemptAutoMap =
        autoFuzzyEnabled &&
        fieldsForMapping.length > 0 &&
        (!shouldSkipFuzzy || shouldForceAutoMap);

      if (shouldAttemptAutoMap && fieldsForMapping.length > 0) {
        try {
          const fieldMapRes = await dispatch(
            runFieldMappingIfNeeded({
              workflowId,
              fields: fieldsForMapping,
              threshold: 60,
              fuzzy_scope: 'e',
              force: shouldForceAutoMap,
            })
          ).unwrap();

          if (fieldMapRes?.alreadyRun) {
            return;
          }

          if (!fieldMapRes.hasFuzzyEdges) {
            toast.info(
              <CustomFuzzyToast message="No entities were auto-mapped by fuzzy logic." />,
              {
                position: 'top-right',
                autoClose: 15000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
              }
            );
          }

          dispatch(
            setMappedEntities({
              workflowId,
              mappedEntities: {
                Source:
                  Object.keys(fieldMapRes?.result?.mapped_entities || {}) || [],
                Destination:
                  Object.values(fieldMapRes?.result?.mapped_entities || {}) || [],
              },
            })
          );

          dispatch(
            setUnmappedEntities({
              workflowId,
              unmappedEntities: {
                Source: fieldMapRes?.result?.unmapped_entities?.Source || [],
                Destination:
                  fieldMapRes?.result?.unmapped_entities?.Destination || [],
              },
            })
          );
        } catch (err) {
          console.error('Auto fuzzy mapping failed:', err);
        }
      }
      // }
    };
    // };

    loadMapping();
  }, [workflowId, finalConfigPayload, shouldSkipFuzzy, autoFuzzyEnabled, dispatch]);

  useEffect(() => {
    if (!workflowId || !finalConfigPayload?.length) return;
    console.log('workflowId::::::', workflowId);
    if (restoredOnceRef.current) return;
    restoredOnceRef.current = true;

    (async () => {
      try {
        await dispatch(
          fetchResolvedFields({
            label: 'FieldResolution',
            workflowId,
            finalConfigPayload,
          })
        ).unwrap();
        const result = await dispatch(getSavedMapping(workflowId)).unwrap();
        const saved = result?.data;
        const hasSaved =
          Array.isArray(saved?.mappings) && saved.mappings.length > 0;

        if (hasSaved) {
          dispatch(
            applySavedMappingIfNeeded({
              workflowId,
              mappings: saved.mappings,
              isOneToMany,
            })
          );

          // updated by vishal for one to many
          if (isOneToMany) {
            dispatch(
              setConnectionDetailsForWorkflow({
                workflowId,
                connectionDetails: saved.mappings,
              })
            );
          }
        }
      } catch (err) {
        console.error('No saved mapping found:', err);
      }
    })();
  }, [dispatch, workflowId, workflowId, finalConfigPayload]);

  const [selectedTab, setSelectedTab] = useState('Mapping');
  const [mainMenu, setMainMenu] = useState('Mapping');
  const [openExitModal, setOpenExitModal] = useState(false);

  const etlMappingRef = useRef();

  const processWorkflowData = () => {
    const formattedNodes = workflowNodes.map((node) => {
      const match = node.data.label.match(/(.*?)\s*\((.*?)\)/);
      const label = match ? match[1].trim() : node.data.label;
      const type = match ? match[2].trim().toLowerCase() : node.type;

      return {
        id: node.id,
        position: node.position,
        label,
        type,
        config: node.data.config || {},
      };
    });

    const formattedEdges = workflowEdges.map((edge) => ({
      id: edge.id,
      source: edge.source,
      target: edge.target,
      animated: edge.animated,
      label: edge.label || '',
      markerEnd: {
        type: 'arrowclosed',
        width: 20,
        height: 20,
        color: '#1976d2',
      },
    }));

    return { nodes: formattedNodes, edges: formattedEdges };
  };

  const workflowData = useMemo(
    () => processWorkflowData(),
    [workflowNodes, workflowEdges]
  );
  console.log('workflow Data:', workflowData);

  // ✅ FIX: Get workflow Redux state to check for saved mapping information
  // const workflowReduxData = useSelector(
  //   (state) => state.workflows.workflows?.[workflowName]
  // );

  // ✅ FIX: Restore mapping state when navigating back to mapping view
  // useEffect(() => {
  //   // If we have no mapping data but workflow has connectionDetails, try to restore
  //   if (
  //     !existingMappingData?.nodes?.length &&
  //     !existingMappingData?.edges?.length &&
  //     (workflowReduxData?.connectionDetails?.length > 0 ||
  //       workflowReduxData?.workflowJson?.mappings?.length > 0)
  //   ) {
  //     toast.info(
  //       'Found existing mapping data. The visualization will be restored when you access the mapping view.',
  //       {
  //         autoClose: 3000,
  //       }
  //     );
  //   }
  // }, [existingMappingData, workflowReduxData, workflowName]);

  const handleTabChange = (tab) => {
    if (tab === 'Dashboard') {
      setOpenExitModal(true);
    } else {
      setMainMenu(tab);
      setSelectedTab(tab);
    }
  };

  const handleCloseExitModal = (action) => {
    setOpenExitModal(false);
    if (action === 'yes') {
      navigate('/userdashboard');
    }
  };

  const handleLogout = useLogout();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <NavigationBar
        selectedTab={selectedTab}
        mainMenu={mainMenu}
        onTabChange={handleTabChange}
        handleLogout={handleLogout}
      />

      <ExitConfirmationModal
        open={openExitModal}
        onClose={handleCloseExitModal}
        onConfirm={() => handleCloseExitModal('yes')}
      />

      <Box sx={{ flex: 1, px: 2,height: '100vh'}}>
        {/* {mappingLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
            }}
          >
            <Typography>Loading fields...</Typography>
            <CircularProgress sx={{ fontSize: '2rem', color: '#1976d2' }} />
          </Box>
        ) : ( */}
        <ReactFlowProvider>
          <ETLMapping ref={etlMappingRef} updatedConfig={workflowData} />
        </ReactFlowProvider>
        {/* )} */}
      </Box>

      {/* <Box sx={{ flex: 1, py: 6, px: 4, position: 'relative' }}>
        <ReactFlowProvider>
          <ETLMapping ref={etlMappingRef} updatedConfig={workflowData} />
        </ReactFlowProvider>

        {mappingLoading && !mappingSaving && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.7)',
              zIndex: 2000,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress sx={{ color: '#1976d2', mb: 2 }} size={50} />
            <Typography sx={{ color: '#1976d2', fontWeight: 500 }}>
              Loading fields...
            </Typography>
          </Box>
        )}

        {mappingSaving && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.7)',
              zIndex: 3000,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress sx={{ color: '#1976d2', mb: 2 }} size={50} />
            <Typography sx={{ color: '#1976d2', fontWeight: 500 }}>
              Saving Mapping...
            </Typography>
          </Box>
        )}
      </Box> */}
    </Box>
  );
};

export default MappingWrapper;
